module.exports = __webpack_public_path__ + "static/media/home-warranty.8c92ceab.svg";